import PropTypes from 'prop-types';

// material
import { ArrowRight, ExpandMore } from '@mui/icons-material';
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Typography,
} from '@mui/material';

// styles
import useStyles from './style';

export default function AccordionSection({ title, items }) {
	const { classes } = useStyles();

	return (
		<Box className={classes.sectionWrap}>
			<Accordion defaultExpanded={true} className={classes.accordion}>
				<AccordionSummary
					expandIcon={<ExpandMore />}
					className={classes.accordionSummary}
				>
					<Typography variant="h5" className={classes.heading}>
						{title}
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					{items.map((item, index) => (
						<Box display="flex" key={index}>
							<ArrowRight color="secondary" fontSize="small" />
							<a href={item.loc} className={classes.link}>
								{item.label}
							</a>
						</Box>
					))}
				</AccordionDetails>
			</Accordion>
		</Box>
	);
}

AccordionSection.propTypes = {
	title: PropTypes.string.isRequired,
	items: PropTypes.array,
};
AccordionSection.defaultProps = {
	items: [],
};
